module.exports = __webpack_public_path__ + "static/media/SmartShop_5-459w.05f6926b.png";